import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import BlogHero from './BlogHero/BlogHero';
import FeaturedPosts from './FeaturedPosts/FeaturedPosts';
import LatestPosts from './LatestPosts/LatestPosts';
import BlogActionCTA from './BlogActionCTA/BlogActionCTA';
import useBlogList from './useBlogList';
import './BlogSkeleton.css';

const Blog = () => {
  const { featuredPosts, latestPosts, categories, loading, error } = useBlogList();

  return (
    <div>
      <Helmet>
        <title>Blog</title>
        <meta
          name="description"
          content="Insights, news, and analysis for the African Energy Community."
        />
        <link rel="canonical" href="https://sonaroid.io/blog" />
      </Helmet>
      <Navbar
        background="#FFFFFF"
        alternative="active"
        bottomBorder="1px solid #ECE9E4"
      />
      <BlogHero />
      {error && !loading ? (
        <div className="page-container">
          <p className="blog-error-state">Unable to load blog posts. Please try again later.</p>
        </div>
      ) : null}
      <FeaturedPosts posts={featuredPosts} loading={loading} />
      <LatestPosts
        posts={latestPosts}
        categories={categories}
        loading={loading}
      />
      <BlogActionCTA />
      <Footer />
    </div>
  );
};

export default Blog;
